<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <button class="btn-back" @click="votar">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                                        </svg>
                                        Voltar
                                    </button>
                                    <h1 class="modern-title">Editais</h1>
                                    <p class="modern-subtitle">Detalhamento do edital de licitação</p>
                                </div>
                                <div class="header-actions" v-if="edital">
                                    <a :href="vertificaUrl(edital.urlEdital)"
                                       class="modern-btn modern-btn-primary"
                                       target="_blank">
                                        Baixar Edital
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="page-container" v-if="edital">

                    <!-- Identity card -->
                    <div class="det-identity-card">
                        <div class="det-identity-card__bar" aria-hidden="true"></div>
                        <div class="det-identity-card__content">
                            <div class="det-identity-card__header">
                                <span class="det-identity-card__label">Órgão / Entidade</span>
                                <span class="det-modality-badge">
                                    <i class="fas fa-landmark"></i>
                                    {{ edital.modalidade }}
                                </span>
                            </div>
                            <h2 class="det-identity-card__razao">{{ edital.entidade }}</h2>
                            <div class="det-identity-card__meta">
                                <span class="det-meta-chip">
                                    <i class="fas fa-map-marker-alt"></i>
                                    {{ edital.ufEntidade }}
                                </span>
                                <span class="det-meta-chip">
                                    <i class="fas fa-calendar-alt"></i>
                                    {{ formatDate(edital.dataLicitacao) }}
                                </span>
                            </div>
                        </div>
                    </div>

                    <!-- Two-column detail grid -->
                    <div class="det-grid">

                        <!-- Dados do edital -->
                        <div class="det-card">
                            <div class="det-card__header">
                                <i class="fas fa-file-alt"></i>
                                Dados do Edital
                            </div>
                            <div class="det-card__body">
                                <p class="det-objeto">{{ edital.objeto }}</p>
                            </div>
                        </div>

                        <!-- Itens do edital -->
                        <div class="det-card">
                            <div class="det-card__header">
                                <i class="fas fa-list-ul"></i>
                                Itens do Edital
                            </div>
                            <div class="det-card__body det-card__body--scroll">
                                <template v-if="edital.descricaoItem && edital.descricaoItem.length > 0">
                                    <div class="det-item"
                                         v-for="(item, index) in edital.descricaoItem"
                                         :key="index"
                                         :style="{ animationDelay: `${index * 40}ms` }">
                                        <span class="det-item__index">{{ index + 1 }}</span>
                                        <span class="det-item__text">{{ item }}</span>
                                    </div>
                                </template>
                                <div v-else class="det-no-items">
                                    <i class="fas fa-inbox"></i>
                                    Nenhum item encontrado
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- CTA link -->
                    <!--<div class="det-cta-bar">
                <a :href="vertificaUrl(edital.urlEdital)"
                   class="det-cta-link"
                   target="_blank">
                    <i class="fas fa-external-link-alt"></i>
                    Acessar o link do edital
                    <i class="fas fa-chevron-right det-cta-link__arrow"></i>
                </a>
            </div>-->

                </div>

                </div>
            </div>
        </div>
        <Modais></Modais>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { urlApi } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'

    export default {
        name: 'DetalheEdital',
        components: { Header, Modais },

        data() {
            return {
                edital: history.state.edital ?? null,
            }
        },

        computed: {
            user() { return this.$store.state.user },
        },

        methods: {
            votar() { this.$router.go(-1) },

            load() {
                if (!this.edital) {
                    this.$router.push({ name: 'Editais' })
                    return
                }
                this.geraLogPesquisaResultado()
            },

            geraLogPesquisaResultado() {
                axios.post(`${urlApi}/Log/LogPesquisaEditalResultados`, {
                    idPesquisaEditais: this.$route.query.idPesquisaEditais,
                    idLicitacao: this.$route.query.index,
                }).then(res => {
                    if (res.data.success) console.log('log ok')
                })
            },

            vertificaUrl(url) {
                if (!url) return '#'
                if (url.indexOf('https') === -1) {
                    url = url.replaceAll('http', 'https')
                }
                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'SC_DWN_EDIT' }).catch(() => { })
                return url
            },

            formatDate(dt) {
                return moment(dt).format('DD/MM/YYYY HH:mm')
            },
        },

        mounted() { this.load() },
    }
</script>

<style lang="scss" scoped>
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
        padding: 2px 0;
    }

    .title-section {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }

    .btn-back {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: none;
        border: none;
        color: #6b7280;
        font-size: 13px;
        font-weight: 600;
        padding: 0;
        margin-bottom: 4px;
        cursor: pointer;
        width: fit-content;
    }

    .btn-back:hover {
        color: #2563eb;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        text-decoration: none;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        color: white;
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    .page-container {
        max-width: 1140px;
        margin: 0 auto;
        padding: 24px 16px 48px;
    }

    .det-identity-card {
        background: #fff;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
        overflow: hidden;
        display: grid;
        grid-template-columns: 6px 1fr;
        margin-bottom: 28px;
        border: 1px solid #e5e7eb;
    }

    .det-identity-card__bar {
        background: #2563eb;
    }

    .det-identity-card__content {
        padding: 24px 28px;
    }

    .det-identity-card__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        gap: 12px;
        flex-wrap: wrap;
    }

    .det-identity-card__label {
        font-size: 11px;
        font-weight: 700;
        letter-spacing: .12em;
        text-transform: uppercase;
        color: #6b7280;
    }

    .det-modality-badge {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: .06em;
        text-transform: uppercase;
        padding: 4px 14px;
        border-radius: 20px;
    }

    .det-identity-card__razao {
        font-size: 20px;
        font-weight: 800;
        color: #1f2937;
        margin: 0 0 14px;
        line-height: 1.3;
        letter-spacing: -0.3px;
    }

    .det-identity-card__meta {
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    .det-meta-chip {
        display: inline-flex;
        align-items: center;
        gap: 7px;
        background: #f8fafc;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 5px 14px;
        font-size: 13px;
        font-weight: 600;
        color: #1f2937;
    }

    .det-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
        margin-bottom: 24px;
    }

    .det-card {
        background: #fff;
        border-radius: 12px;
        border: 1px solid #e5e7eb;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        display: flex;
        flex-direction: column;
    }

    .det-card__header {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 20px;
        background: #f8fafc;
        border-bottom: 1px solid #e5e7eb;
        font-size: 14px;
        font-weight: 800;
        color: #1f2937;
    }

    .det-card__header i {
        color: #2563eb;
    }

    .det-card__body {
        padding: 20px;
        flex: 1;
    }

    .det-card__body--scroll {
        max-height: 340px;
        overflow-y: auto;
        padding: 12px 20px;
    }

    .det-objeto {
        font-size: 14px;
        color: #1f2937;
        line-height: 1.75;
        margin: 0;
    }

    .det-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 10px 0;
        border-bottom: 1px solid #f3f4f6;
    }

    .det-item:last-child {
        border-bottom: none;
    }

    .det-item__index {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        background: rgba(37, 99, 235, 0.1);
        color: #1d4ed8;
        border-radius: 50%;
        font-size: 11px;
        font-weight: 800;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 1px;
    }

    .det-item__text {
        font-size: 13px;
        color: #1f2937;
        line-height: 1.6;
    }

    .det-no-items {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 10px;
        padding: 32px 0;
        color: #6b7280;
        font-size: 14px;
    }

    [data-bs-theme="dark"] .det-identity-card,
    [data-bs-theme="dark"] .det-card {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .det-identity-card__razao,
    [data-bs-theme="dark"] .det-card__header,
    [data-bs-theme="dark"] .det-objeto,
    [data-bs-theme="dark"] .det-item__text {
        color: #f9fafb;
    }

    @media (max-width: 768px) {
        .modern-title {
            font-size: 24px;
        }

        .header-content {
            flex-direction: column;
            align-items: flex-start;
        }

        .det-grid {
            grid-template-columns: 1fr;
        }
    }

    @media print {
        .btn-back,
        .modern-btn {
            display: none !important;
        }
    }
</style>

